import React from "react";
import useInViewAnimation from "../hooks/useInViewAnimation";
import "./SolarOrbit.css";

/**
 * SolarOrbit — a decorative glowing sun with orbiting rings.
 * size: "sm" | "md" | "lg"
 */
export default function SolarOrbit({ size = "md", className = "" }) {
  const ref = useInViewAnimation();

  return (
    <div
      ref={ref}
      className={`solar-orbit solar-orbit--${size} ${className}`}
      aria-hidden="true"
    >
      <div className="solar-orbit__glow" />
      <div className="solar-orbit__core" />
      <div className="solar-orbit__ring solar-orbit__ring--1" />
      <div className="solar-orbit__ring solar-orbit__ring--2" />
      <div className="solar-orbit__ring solar-orbit__ring--3" />
    </div>
  );
}
